import React from 'react';
import { Modal } from '@tencent/dui/lib/components/Modal';
import { Select } from '@tencent/dui/lib/components/Select';
import i18n from '@i18next/i18n';
import { STTrendlineType } from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/sdk-model.interface';
import type { IChartModel } from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/chart-model.interface';
import { IChartTrendlineManager } from '@src/slide/application/service/chart-manager/chart-manager.interface';
export default class ChartTrendlineManager implements IChartTrendlineManager {
    /**
     * 当前关联的chart model对象
     */
    private chartModel?: IChartModel;
    /**
     * 面板是否显示
     */
    private isModalShown = false;

    /**
     * 系列idx，作用于charts唯一的索引
     */
    private selectedSeriesIdx;
    /**
     * 趋势线类型
     */
    private trendlineType?: STTrendlineType;

    public showSeriesSelectModal(chartModel: IChartModel, trendlineType?: STTrendlineType): void {
        if (this.isModalShown) return;
        this.chartModel = chartModel;
        this.trendlineType = trendlineType;
        Modal.confirm({
            title: i18n.t('添加趋势线'),
            content: this.getSeriesSelect(),
            onOk: () => {
                this.handleTrendlineCommit();
                this.onModalClose();
            },
            onCancel: () => this.onModalClose(),
            onClose: () => this.onModalClose(),
        });
        this.isModalShown = true;
    }

    private onModalClose() {
        this.isModalShown = false;
        this.selectedSeriesIdx = undefined;
        this.trendlineType = undefined;
        this.chartModel = undefined;
    }

    private getSeriesSelect() {
        if (!this.chartModel) return;
        const { charts } = this.chartModel.plotArea;
        const allSeries = charts.map(chart => chart.series).flat();
        this.selectedSeriesIdx = allSeries[0].idx;
        return (
            <Select
                style={{ width: 350 }}
                onChange={value => (this.selectedSeriesIdx = Number.parseInt(value as string, 10))}
                defaultValue={`${allSeries[0].idx}`}
            >
                {allSeries.map(series => (
                    <Select.Option key={series.idx} value={`${series.idx}`}>
                        {series.name}
                    </Select.Option>
                ))}
            </Select>
        );
    }

    private handleTrendlineCommit() {
        if (this.chartModel) {
            const allSeries = this.chartModel.plotArea.charts
                .map(chart => chart.getSubChartProperty().series)
                .flat();
            const ser = allSeries.find(ser => ser.idx === this.selectedSeriesIdx);
            if (ser) {
                ser.createTrendline(this.trendlineType || STTrendlineType.linear);
            }
        }
    }
}
